var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticonMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5205 30.9474C62.5205 48.0372 48.6629 61.8947 31.5731 61.8947C14.4833 61.8947 0.625732 48.0372 0.625732 30.9474C0.625732 13.8576 14.4833 0 31.5731 0C48.6629 0 62.5205 13.8576 62.5205 30.9474Z",
    fill: "#151514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.209 16.9282H34.215L45.5968 44.9836H41.9117L39.0692 37.8923H25.6873L22.925 44.9836H19.28L30.2205 16.9282H30.209ZM37.6995 34.4814L32.2493 20.8952L26.9997 34.4814H37.6995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticonMedium);
export default __webpack_public_path__ + "static/media/articonMedium.90fce9d7.svg";
export { ForwardRef as ReactComponent };var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticonMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5205 30.9474C62.5205 48.0372 48.6629 61.8947 31.5731 61.8947C14.4833 61.8947 0.625732 48.0372 0.625732 30.9474C0.625732 13.8576 14.4833 0 31.5731 0C48.6629 0 62.5205 13.8576 62.5205 30.9474Z",
    fill: "#151514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.209 16.9282H34.215L45.5968 44.9836H41.9117L39.0692 37.8923H25.6873L22.925 44.9836H19.28L30.2205 16.9282H30.209ZM37.6995 34.4814L32.2493 20.8952L26.9997 34.4814H37.6995Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticonMedium);
export default __webpack_public_path__ + "static/media/articonMedium.90fce9d7.svg";
export { ForwardRef as ReactComponent };